// ─────────────────────────────────────────────────────────────
// KONFIGURACJA STRONY - edytuj ceny, daty, etykietę i opinie tutaj.
// ─────────────────────────────────────────────────────────────

export const PREMIERE_DATE = "13.11.2026";

// Koniec ceny Early Bird: północ z 30 na 31 października 2026 (czas polski).
// Licznik liczy z tej daty - po jej upływie strona pokaże „Early Bird zakończony"
// i ceny automatycznie zmienią się na regularne.
export const PRESALE_DEADLINE_ISO = "2026-10-31T00:00:00+01:00";
export const PRESALE_DEADLINE_LABEL = "30 października o północy";

// Kod zniżkowy -50 zł: komunikaty widoczne do końca 27.10 (północ z 27 na 28.10,
// czas polski). Po tym terminie strona sama wraca do komunikatów Early Bird.
export const PROMO_CODE = "MINUS50";
export const PROMO_CODE_UNTIL_ISO = "2026-10-28T00:00:00+01:00";
export const REGULAMIN_URL = "https://edunation.com.pl/regulamin/";
export const FB_REVIEWS_URL = "https://www.facebook.com/helloedunation/reviews";

// Który pakiet dostaje etykietę „Najczęściej wybierany".
// Dozwolone: "kurs" | "mini" | "maxi" | null (bez etykiety)
export const RECOMMENDED_PACKAGE = "mini";

export const PACKAGES = [
    {
        id: "kurs",
        name: "100 rozwiązań",
        tagline: "Sam kurs",
        selectorLabel: "Chcę tylko kurs",
        mockup: "/images/mockup-kurs-new.webp",
        extras: [],
        features: [
            "Kurs „100 rozwiązań na trudne sytuacje na lekcji z dorosłymi”",
            "5 modułów",
            "100 kompleksowych lekcji",
            "Dostęp na 10 miesięcy",
            "Certyfikat ukończenia",
        ],
        regularPrice: 499,
        presalePrice: 399,
        lowestPrice30d: 299,
        buyUrl: "https://online.edunation.com.pl/s/100-rozwiazan-na-trudne-sytuacje-na-lekcji-z-doroslym.html",
        cta: "Wybieram kurs",
    },
    {
        id: "mini",
        name: "Pakiet MINI",
        tagline: "Kurs + Akademia",
        selectorLabel: "Chcę więcej materiałów",
        mockup: "/images/mockup-mini-new.webp",
        extras: [
            { label: "Akademia Nauczania Dorosłych", tint: "bg-hl-pink" },
            { label: "Dorosły w 40 odsłonach", tint: "bg-hl-cyan" },
            { label: "E-book: 40 pomysłów", tint: "bg-hl-lav" },
        ],
        features: [
            "Kurs „100 rozwiązań na trudne sytuacje na lekcji z dorosłymi”",
            "Kurs „Akademia Nauczania Dorosłych”",
            "Mini-kurs „Dorosły w 40 odsłonach”",
            "E-book „40 pomysłów na uczenie dorosłych online”",
        ],
        regularPrice: 946,
        presalePrice: 569,
        lowestPrice30d: 439,
        buyUrl: "https://online.edunation.com.pl/s/mini-pakiet-rozwiazan-na-trudne-sytuacje-na-lekcji-z-doroslym.html",
        cta: "Wybieram pakiet MINI",
    },
    {
        id: "maxi",
        name: "Pakiet MAXI",
        tagline: "Pełne kompendium",
        selectorLabel: "Chcę pełne kompendium",
        mockup: "/images/mockup-maxi-new.webp",
        extras: [
            { label: "Akademia Nauczania Dorosłych", tint: "bg-hl-pink" },
            { label: "Dorosły w 40 odsłonach", tint: "bg-hl-cyan" },
            { label: "Wielkie kompendium", tint: "bg-tang" },
            { label: "E-book: 40 pomysłów", tint: "bg-hl-lav" },
        ],
        features: [
            "Kurs „100 rozwiązań na trudne sytuacje na lekcji z dorosłymi”",
            "Kurs „Akademia Nauczania Dorosłych”",
            "Mini-kurs „Dorosły w 40 odsłonach”",
            "„Wiem wszystko o uczeniu dorosłych. Wielkie kompendium”",
            "E-book „40 pomysłów na uczenie dorosłych online”",
        ],
        regularPrice: 1345,
        presalePrice: 819,
        lowestPrice30d: 699,
        buyUrl: "https://online.edunation.com.pl/s/maxi-pakiet-rozwiazan-na-trudne-sytuacje-na-lekcji-z-doroslym.html",
        cta: "Wybieram pakiet MAXI",
    },
];

// Opinie - prawdziwe cytaty z https://www.facebook.com/helloedunation/reviews
// Format: { quote: "…", author: "Imię Nazwisko" }
// Pusta lista = na stronie pokażą się oznaczone miejsca do uzupełnienia.
export const REVIEWS = [
    {
        quote: "To, co szczególnie cenię, to praktyczność - zero teorii do szuflady, tylko konkret, który mogłam od razu wdrożyć w mojej szkole. Zaczęłam inaczej patrzeć na zespół, na uczniów, na siebie.",
        author: "Przygoda z angielskim",
    },
    {
        quote: "Szkolenia bardzo interesujące, na wysokim poziomie, mega inspirujące i obsługa, czyli faktury itp.... błyskawiczna... Mam już 7 kurs i naprzemiennie się szkolę.",
        author: "Katarzyna J.",
    },
    {
        quote: "Wasze tematy z Edunation wykorzystuję na zajęciach! To miło słyszeć, jak uczniowie mówią: Ale ta lekcja była faaajna! Dziękuję Wam, że podając nam pomysły projektów, kreatywnych zajęć do realizacji, dajecie radość uczniom z nauki! To Wielka Sztuka! DZIĘKUJĘ!",
        author: "Iwona S.",
    },
    {
        quote: "Rewelacyjne, merytorycznie doskonałe kursy na najwyższym poziomie, łączące wiedzę z praktyką, zaangażowanie ze sprawdzonymi faktami i umiejętność przekazywania wiedzy z zarażaniem entuzjazmem. Wystarczy żeby czerpać pełnymi garściami!",
        author: "Anna K.",
    },
];

export const CONTACT = {
    name: "Ewa Siereńska",
    phoneDisplay: "577 033 633",
    phoneHref: "tel:+48577033633",
    email: "ewa.sierenska@edunation.com.pl",
    photo: "/images/ewa-new.webp",
    scope: [
        "płatności i faktury",
        "zaświadczenia",
        "problemy z logowaniem",
        "pytania związane z kursem",
    ],
};

export const formatPln = (n) =>
    `${n.toLocaleString("pl-PL").replace(/,/g, " ")} PLN`;
